// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e01HZ","timer":"styles_timer__IdF18","item":"styles_item__BLR87","show":"styles_show__YJSrz"};